import { makeStyles } from '@material-ui/core';
import { Theme } from '@bizzabo/design-system';

export const useStyles = makeStyles<Theme>(
    theme => ({
        drawerLink: {
            ...theme.typography.t30,
            color: 'inherit', // TODO: use the customization theme
            fontSize: 20,
            textDecoration: 'none',
            cursor: 'pointer',
            position: 'relative',
        },
    }),
    { classNamePrefix: 'drawer-link-base' }
);
